import { render, staticRenderFns } from "./assetWithdraw.vue?vue&type=template&id=7a20dc68"
import script from "./assetWithdraw.vue?vue&type=script&lang=js"
export * from "./assetWithdraw.vue?vue&type=script&lang=js"
import style0 from "./assetWithdraw.vue?vue&type=style&index=0&id=7a20dc68&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports